// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBWhaNuCRehgFtstpMZWZ4ZcGXGjpaQHJ8",
  authDomain: "dosaaf-2dec9.firebaseapp.com",
  databaseURL: "https://dosaaf-2dec9.firebaseio.com",
  projectId: "dosaaf-2dec9",
  storageBucket: "dosaaf-2dec9.appspot.com",
  messagingSenderId: "760659706206",
  appId: "1:760659706206:web:9272cf4c68ea19e0cdcfcf",
  measurementId: "G-N8832DBEXH"
};
export default firebaseConfig;
